import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";
import boardingPass from "../ActivistAssets/ActivistPictures/MMCActivist-Boarding Pass.jpg";
export const influencerNoteContent: NoteContent[] = [
  {
    title: "Toku reservation tonight 8.30pm",
    date: "2 April 2024",
    content: [
      {
        entry: "Toku reservation tonight 8.30pm",
      },
    ],
    locked: false,
  },
  {
    title: "Ryan talk Thursday 7 March",
    date: "27 February 2024",
    content: [
      {
        entry: "Ryan talk Thursday 7 March",
      },
    ],
    locked: false,
  },
  {
    title: "Arcadia Vineyard tours California",
    date: "18 February 2024",
    content: [
      {
        entry: "Arcadia Vineyard tours California",
      },
    ],
    locked: false,
  },
  {
    title: "Opuntia ficus-indica",
    date: "15 February 2024",
    content: [
      {
        entry: "Opuntia ficus-indica",
      },
    ],
    locked: false,
  },
  {
    title: "The Pearl Button Netflix",
    date: "13 January 2023",
    content: [
      {
        entry: "The Pearl Button Netflix",
      },
    ],
    locked: false,
  },
  {
    title: "The River - Jean Renoir",
    date: "12 October 2009",
    content: [
      {
        entry: "The River - Jean Renoir",
      },
    ],
    locked: false,
  },
  {
    title: "Boarding pass",
    date: "10 Aug 2009",
    content: [
      {
        entry: boardingPass,
      },
    ],
    locked: false,
  },
];
